export default __webpack_public_path__ + "static/media/Share.fef5bdf4.svg";